module.exports = __webpack_public_path__ + "static/media/lc-staff-review.2f146ad0.png";